import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { toggleInfoSlider } from "../actions/AccountAction";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../assets/css/InfoSlider.css";

const TREES_INFO_BASE_URL = "https://o-sn.be/seg/app-files";

const PrevArrow = ({ onClick }) => (
  <button className="info_slider_arrow info_slider_arrow_prev" onClick={onClick}>
    &#8249;
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className="info_slider_arrow info_slider_arrow_next" onClick={onClick}>
    &#8250;
  </button>
);

const InfoSlider = () => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.general.lang);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    swipeToSlide: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const sliderImages = Array.from({ length: 7 }, (_, i) => {
    const paddedNumber = (i + 1).toString().padStart(2, "0");
    return `${TREES_INFO_BASE_URL}/${lang}/trees-info_${lang}_${paddedNumber}.svg`;
  });

  const handleClose = () => {
    dispatch(toggleInfoSlider(false));
  };

  return (
    <div id="info_slider_wrapper">
      <div className="info_slider_content">
        <button className="info_slider_close_btn" onClick={handleClose}>
          &#10005;
        </button>
        <div className="info_slider_container">
          <Slider {...sliderSettings}>
            {sliderImages.map((imageUrl, index) => (
              <div key={index} className="info_slider_slide">
                <img
                  src={imageUrl}
                  alt={`trees-info-${index + 1}`}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default InfoSlider;
